module.exports = __webpack_public_path__ + "img/source.00f19a03.png";